import AsyncStorage from '@react-native-async-storage/async-storage';
import { createJSONStorage, persist } from 'zustand/middleware';
import { createWithEqualityFn } from 'zustand/traditional';
import { removePersistedChatMediaFile } from '@/utils/chatMediaCache';

export type ChatMediaCacheAsset = {
  id: string;
  chatId: string;
  path: string;
  uploadUri?: string | null;
  storageUri: string | null;
  mimeType: string | null;
};

type ChatMediaCacheState = {
  assets: Record<string, ChatMediaCacheAsset>;
};

const initialState: ChatMediaCacheState = {
  assets: {},
};

const useChatMediaCacheStore = createWithEqualityFn<ChatMediaCacheState>()(
  process.env.EXPO_OS === 'web'
    ? () => initialState
    : persist(() => initialState, {
        name: 'useChatMediaCacheStore',
        storage: createJSONStorage(() => AsyncStorage),
      }),
);

export default useChatMediaCacheStore;

export function setChatMediaCacheAsset(asset: ChatMediaCacheAsset) {
  useChatMediaCacheStore.setState((state) => ({
    assets: {
      ...state.assets,
      [asset.id]: asset,
    },
  }));
}

export function getChatMediaCacheAsset(id: string) {
  return useChatMediaCacheStore.getState().assets[id];
}

function clearChatMediaCacheAsset(id: string) {
  useChatMediaCacheStore.setState((state) => {
    const nextAssets = { ...state.assets };
    delete nextAssets[id];

    return {
      assets: nextAssets,
    };
  });
}

export async function removeChatMediaCacheAsset(id: string) {
  const asset = getChatMediaCacheAsset(id);

  if (asset?.storageUri) {
    await removePersistedChatMediaFile(asset.storageUri);
  }

  clearChatMediaCacheAsset(id);
}
